module.exports = __webpack_public_path__ + "img/personalcenter-checkbox-selected.5e7b9cd5.svg";